export const ALIGNMENT = {
  CENTER: 'center',
  LEFT: 'left',
};

export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
